﻿import * as interop from "./interop";

declare global {
    interface Window {
        TiyorShearwall: any;
    }
}

window.TiyorShearwall = {
    interop,
};

